module.exports = __webpack_public_path__ + "img/vice_chairman_and_ceo_statement.69b0923d.jpg";